<template>
    <div>
        <div v-for="(chatMessage, index) in chatMessages" :key="index">
            <make-model-bot-chat @onMakeModelAnswerSelected="onQuestionAnsweredCallback($event)"
                @onMakeModelHelpSelected="helpMeCallBack()" @onChatFinished="onChatFinished" :chatMessage="chatMessage"
                :conversationId="conversationId" />
        </div>
    </div>
</template>

<script lang="ts">
import MakeModelChatQueueStatus from '@/enums/MakeModelChatMessageQueueStatus';
import ChatMessage from '@/models/vehicle/makeModelBot/chatMessage';
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import MakeModelBotChatComponent from './MakeModelBotChatComponent.vue';

@Component({
    components: {
        'make-model-bot-chat': MakeModelBotChatComponent
    }
})

export default class ChatContainerComponent extends Vue {
    @Prop({ required: true })
    public chatMessageQueue!: ChatMessage[];

    @Prop({ required: true })
    private conversationId!: string;

    private chatMessages: ChatMessage[] = [];

    private makeModelChatQueueStatus: MakeModelChatQueueStatus = MakeModelChatQueueStatus.Empty;

    private queueInterval: any | null = null;
    
    mounted() {
        this.$events.on('formReset', this.reset);
        this.InitiateQueueListener();
        this.$watch(() => this.chatMessageQueue, (newVal, oldVal) => this.handleQueueChange(newVal, oldVal));
    }

    beforeDestroy() {
        this.$events.off('formReset', this.reset);
        if (this.queueInterval !== null) {
            clearInterval(this.queueInterval);
        }
    }

    private reset() {
        this.chatMessages = [];
        this.chatMessageQueue = [];
    }

    private onQuestionAnsweredCallback(answer: string) {
        this.$emit('onMakeModelAnswerSelected', answer);
    }

    private helpMeCallBack() {
        this.$emit('onMakeModelHelpSelected');
    }

    private onChatFinished() {
        this.$emit('onChatFinished');
    }

    private onQueueStatusChanged() {
        this.$emit('onQueueStatusChanged', this.makeModelChatQueueStatus);
    }

    private handleQueueChange(newVal: ChatMessage[], oldVal: ChatMessage[]) {
        if (oldVal.length > newVal.length && newVal.length !== 0) {
            return;
        }

        if (newVal.length === 0) {
            this.makeModelChatQueueStatus = MakeModelChatQueueStatus.Finished;
        } else {
            this.makeModelChatQueueStatus = MakeModelChatQueueStatus.Working;
        }

        this.onQueueStatusChanged();
    }

    private InitiateQueueListener(): void {
        this.queueInterval = setInterval(() => {
            if (this.chatMessageQueue.length === 0 && this.chatMessages.length === 0) {
                return;
            }

            if (!this.chatMessages[this.chatMessages.length - 1]) {
                this.MoveMessageFromQueue();
            }

            if (this.chatMessages[this.chatMessages.length - 1].isFinished && this.makeModelChatQueueStatus !== MakeModelChatQueueStatus.Finished) {
                this.MoveMessageFromQueue();
                this.scrollDown();
            }
        }, 600);
    }

    private MoveMessageFromQueue(): void {
        if (this.chatMessageQueue[0] && !this.chatMessages.includes(this.chatMessageQueue[0])) {
            this.chatMessages.push(this.chatMessageQueue[0]);
            this.chatMessageQueue.shift();
            this.scrollDown();
        }
    }

    private scrollDown(): void {
        this.$nextTick(() => {
            const nestedElement = document.getElementById('make-model-chat-messages');
            if (nestedElement === null) {
                console.error('Element with id "make-model-chat-messages" not found.');
                return;
            }
            if (nestedElement.getBoundingClientRect().bottom > window.innerHeight || nestedElement.getBoundingClientRect().top < 0) {
                nestedElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
            }
        });
    }
}
</script>
